import React from 'react';
import styled from 'styled-components';

import cross from '../images/Cross.svg';
import iconLogo from '../images/IconLogo.png';

import { useIconSwapService } from './IconSwapService.jsx';

export const ResponsiveLogin = () => {
  const { handleLogin } = useIconSwapService();

  return (
    <ResponsiveLoginWrapper>
      <MenuHeading>
        <TopLine>
          <MenuHeadingText>Log in to start swapping</MenuHeadingText>
          <CrossImage src={cross} alt="Close" />
        </TopLine>
        <MenuHeadingSubText>
          Log into your wallet to use ICONswap
        </MenuHeadingSubText>
      </MenuHeading>
      <MenuBody>
        <LoginButton
          onClick={() => {
            // @ts-ignore
            handleLogin();
          }}
        >
          <IconLogo src={iconLogo} alt="Logo" />
          <LoginButtonText>Log in with ICON</LoginButtonText>
        </LoginButton>
      </MenuBody>
    </ResponsiveLoginWrapper>
  );
};

export default ResponsiveLogin;

const ResponsiveLoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 217px;
  width: 100vw;
  border: 1px solid #d3d7e0;
  border-radius: 10px 10px 0 0;
  background-color: #ffffff;
`;

const MenuHeading = styled.div`
  height: 100px;
  padding: 20.5px;
  display: flex;
  flex-direction: column;
`;

const TopLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const MenuHeadingText = styled.span`
  color: #0c0a0b;
  font-family: 'Avenir Next';
  font-size: 19px;
  font-weight: 600;
`;

const CrossImage = styled.img`
  height: 14.82px;
  width: 14px;
`;

const MenuHeadingSubText = styled.span`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const MenuBody = styled.div`
  border-top: 1px solid #e8ebec;
`;

const LoginButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  width: 300px;
  height: 50px;
  background-color: #007d81;
  border-radius: 4px;
  margin-top: 30px;
  margin-left: 38px;
  margin-right: 38px;
`;

const LoginButtonText = styled.span`
  font-family: 'Avenir Next';
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
`;

const IconLogo = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 10px;
`;
